<template>
	<v-menu :open-on-hover="!display_icon" offset-y :open-delay="1000">
		<template v-slot:activator="{ on }">
			<v-icon
				v-if="display_icon"
				color="background lighten-4"
				v-on="on">
				{{ display_icon }}
			</v-icon>
			<v-chip
				v-else
				label small :close="state !== 'loading'"
				v-on="on"
				:class="{'not-found': state === 'not_found'}"
				@input="$emit('remove')">
				<span v-if="state === 'found'">{{ chip_label }}</span>
				<span v-if="state === 'not_found'">
					{{ asset_id }}
				</span>
				<span v-else-if="state === 'loading'">
					{{ asset_id }}
					<v-progress-circular
						indeterminate
						:size="18"
						:width="2"
						class="ml-2"
						color="background lighten-5">
					</v-progress-circular>
				</span>
			</v-chip>
		</template>
		<v-card class="background">
			<v-card-title class="pt-2 pb-0 subheading" v-if="state === 'found'">
				<v-spacer></v-spacer>
				<a :href="asset_url" target="_blank">
					{{ asset.id }}
					<span class="mx-1">|</span>
					{{ asset.ref_material }}
					<v-icon small style="margin-bottom: 2px">open_in_new</v-icon>
				</a>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-card-text :class="{'text-center': state !== 'found' }">
				<v-progress-circular
					v-if="state === 'loading'"
					indeterminate
					:size="32"
					:width="2"
					color="background lighten-5">
				</v-progress-circular>
				<span v-if="state === 'not_found'"
					class="orange--text text--lighten-2">
					Asset introuvable
				</span>
				<table v-if="state === 'found'">
					<tr>
						<th>Titre</th>
						<td>
							<a :href="title_url" target="_blank">
								{{ title_name }}
								<v-icon small>open_in_new</v-icon>
							</a>
						</td>
					</tr>
					<tr>
						<th>Titre alt</th>
						<td>{{ title_alternative }}</td>
					</tr>
					<tr>
						<th>Programme</th>
						<td>{{ program_lib_type_prgm }}</td>
					</tr>
					<tr>
						<th>Version</th>
						<td>{{ program_version }}</td>
					</tr>
					<tr>
						<th>Observation</th>
						<td>{{ asset.observation || '-' }}</td>
					</tr>
					<tr>
						<th>Duration</th>
						<td>{{ asset.duration || '-' }}</td>
					</tr>
					<tr>
						<th>Poids</th>
						<td>{{ asset.asset_size | humanizeBytes1000 }}</td>
					</tr>
					<tr>
						<th>Prorio</th>
						<td>{{ t_aux_name }}</td>
					</tr>
					<tr>
						<th>Type</th>
						<td>{{ type_sup }}</td>
					</tr>
					<tr>
						<th>Norme</th>
						<td>{{ asset.norm || '-' }}</td>
					</tr>
					<tr>
						<th>Proxy</th>
						<td>
							<v-icon small v-if="asset.has_proxy" color="green accent-2">
								done
							</v-icon>
							<v-icon small v-else color="error accent-2">
								block
							</v-icon>
						</td>
					</tr>
					<tr>
						<th>Verif</th>
						<td>
							<v-icon small v-if="asset.has_rv" color="green accent-2">
								done
							</v-icon>
							<v-icon small v-else color="error accent-2">
								block
							</v-icon>
							<v-btn
								v-if="asset.has_rv"
								small icon flat
								class="my-0"
								:href="`${asset_url}rv/`"
								target="_blank">
								<v-icon>open_in_new</v-icon>
							</v-btn>
						</td>
					</tr>
					<tr>
						<th>BeHive categorie</th>
						<td>{{ asset.behive_category }}</td>
					</tr>
					<tr>
						<th>Vidéo</th>
						<td v-if="resume_detail_video.length">
							<v-chip
								label small
								color="background lighten-2"
								v-for="(item, i) in resume_detail_video"
								:key="'video_' + i">
								{{ item }}
							</v-chip>
						</td>
						<td v-else>-</td>
					</tr>
					<tr>
						<th>Audio</th>
						<td v-if="resume_detail_audio.length">
							<v-chip
								label small
								color="background lighten-2"
								v-for="(item, i) in resume_detail_audio"
								:key="'audio_' + i">
								{{ item }}
							</v-chip>
						</td>
						<td v-else>-</td>
					</tr>
					<tr>
						<th>Sous-titres</th>
						<td v-if="resume_detail_subtitle.length">
							<v-chip
								label small
								color="background lighten-2"
								v-for="(item, i) in resume_detail_subtitle"
								:key="'subtitle_' + i">
								{{ item }}
							</v-chip>
						</td>
						<td v-else>-</td>
					</tr>
				</table>
			</v-card-text>
		</v-card>
	</v-menu>
</template>

<script>
// https://behive.hiventy.com/dashboard/materials/maestro-2134/
// https://staging.behive.hiventy.com/dashboard/materials/maestro-2134/rv/
// https://staging.behive.hiventy.com/dashboard/title/503005/
export default {
	props: [ 'asset_id', 'asset', 'display_icon' ],
	computed: {
		state () {
			if (this.asset === undefined) return 'loading'
			if (this.asset.not_found) return 'not_found'
			return 'found'
		},
		chip_label () {
			let label = [this.asset.id]
			if (this.title_name !== '-') label.push(this.title_name)
			if (this.type_sup !== '-') label.push(this.type_sup)
			return label.join(' | ')
		},
		title_name () {
			return this.$commons.deepGet(this.asset, 'title.name', '-')
		},
		title_url () {
			let titleID = this.$commons.deepGet(this.asset, 'title.id')
			let url = window.appConfig._$ou3iju
			return url + '/dashboard/title/' + titleID + '/'
		},
		asset_url () {
			let url = window.appConfig._$ou3iju
			return url + '/dashboard/materials/' + this.asset_id + '/'
		},
		title_alternative () {
			return this.$commons.deepGet(this.asset, 'title.alternative', '-')
		},
		type_sup () {
			return this.$commons.deepGet(this.asset, 'type_sup.lib_type_sup', '-')
		},
		t_aux_name () {
			return this.$commons.deepGet(this.asset, 't_aux.name', '-')
		},
		program_lib_type_prgm () {
			return this.$commons.deepGet(this.asset, 'program.type_prgm.lib_type_prgm', '-')
		},
		program_version () {
			return this.$commons.deepGet(this.asset, 'program.version', '-')
		},
		resume_detail_video () {
			return this.$commons.deepGet(this.asset, 'resume_detail.video', [])
		},
		resume_detail_audio () {
			return this.$commons.deepGet(this.asset, 'resume_detail.audio', [])
		},
		resume_detail_subtitle () {
			return this.$commons.deepGet(this.asset, 'resume_detail.subtitle', [])
		}
	}
}
</script>

<style lang="stylus" scoped>
table
	th
	td
		padding: 2px 4px
	th
		font-weight: normal
		color: var(--v-background-lighten5)
	tr:not(:last-child)
		border-bottom: 1px solid var(--v-background-lighten2)
	.v-chip
		margin: 0 4px 0 0
		height: 22px !important
		border: 1px solid var(--v-background-lighten3) !important
		.v-chip__content
			height: 22px !important

.v-card
	border: 1px solid var(--v-background-lighten3) !important
	border-radius: 4px

.not-found
	color: var(--v-orange-lighten2) !important

a
	color: white
	.v-icon
		color: white
a:hover
	color: var(--v-primary-base)
	.v-icon
		color: var(--v-primary-base)
</style>



// WEBPACK FOOTER //
// src/components/asset_chip.vue